import PropTypes from 'prop-types';

export const SHARE_LINKS = {
  SHARE_LINK: 'market_product_share_link',
};

const propType = {
  key: PropTypes.string,
  marketProductId: PropTypes.string,
};

export default { propType };
